import Splide from '@splidejs/splide';

export default class SplideJS {

    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind() {
        this.setSrcs();

        const elems = document.querySelectorAll('.splide-auto-mount');
        elems.forEach(elem => {
            new Splide( elem ,{
                autoplay: true
            }).mount();
        });

        window.addEventListener('resize', e => {
            this.setSrcs();
        })

    }

    setSrcs()
    {
        if($(window).width() < 768)
        {
            this.$view.find('img').each(function(){
                $(this).prop('src', $(this).data('resp-src'));
                $(this).parent('picture').find('source').prop('srcset', $(this).data('resp-src'));
            });
        } else {
            this.$view.find('img').each(function() {
                $(this).prop('src', $(this).data('desk-src'));
                $(this).parent('picture').find('source').prop('srcset', $(this).data('desk-src'));
            });
        }
    }
}


// WEBPACK FOOTER //
// ./public/frontend/js/components/SplideJS.js